import {
  addDays,
  addMonths,
  addQuarters,
  addYears,
  endOfDay,
  endOfMonth,
  endOfQuarter,
  endOfWeek,
  endOfYear,
  startOfDay,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
  startOfYear,
} from 'date-fns';
import { weekdaysNumberMap } from 'shared/constants';
import { FilterDocumentDateFilterTypes } from 'shared/types/filter-document';
import { Timestamp } from 'shared/types/timestamp';
import { WeekDays } from 'shared/types/week-days';

export type DateRange = {
  start: Date;
  end: Date;
};

export const calculateDeadlinePresetDates = (
  preset: FilterDocumentDateFilterTypes,
  { today, weekStartsOn }: { today: Timestamp; weekStartsOn: WeekDays },
): DateRange | null => {
  const weekOptions = { weekStartsOn: weekdaysNumberMap[weekStartsOn] };

  switch (preset) {
    case FilterDocumentDateFilterTypes.Today: {
      return {
        start: startOfDay(today),
        end: endOfDay(today),
      };
    }
    case FilterDocumentDateFilterTypes.ThisWeek: {
      return {
        start: startOfWeek(today, weekOptions),
        end: endOfWeek(today, weekOptions),
      };
    }
    case FilterDocumentDateFilterTypes.NextWeek: {
      const nextWeekStart = addDays(today, 7);
      return {
        start: startOfWeek(nextWeekStart, weekOptions),
        end: endOfWeek(nextWeekStart, weekOptions),
      };
    }
    case FilterDocumentDateFilterTypes.ThisMonth: {
      return {
        start: startOfMonth(today),
        end: endOfMonth(today),
      };
    }
    case FilterDocumentDateFilterTypes.NextMonth: {
      const nextMonthStart = addMonths(today, 1);
      return {
        start: startOfMonth(nextMonthStart),
        end: endOfMonth(nextMonthStart),
      };
    }
    case FilterDocumentDateFilterTypes.ThisQuarter: {
      return {
        start: startOfQuarter(today),
        end: endOfQuarter(today),
      };
    }
    case FilterDocumentDateFilterTypes.NextQuarter: {
      const nextQuarterStart = addQuarters(today, 1);
      return {
        start: startOfQuarter(nextQuarterStart),
        end: endOfQuarter(nextQuarterStart),
      };
    }
    case FilterDocumentDateFilterTypes.ThisYear: {
      return {
        start: startOfYear(today),
        end: endOfYear(today),
      };
    }
    case FilterDocumentDateFilterTypes.NextYear: {
      const nextYearStart = addYears(today, 1);
      return {
        start: startOfYear(nextYearStart),
        end: endOfYear(nextYearStart),
      };
    }
    case FilterDocumentDateFilterTypes.HasDeadline:
    case FilterDocumentDateFilterTypes.NoDeadline:
    case FilterDocumentDateFilterTypes.Custom: {
      return null;
    }
  }
};
